import React from 'react'
import Responsive from 'react-responsive'
import * as constants from '../static/constants'

export const IsDesktop = props => <Responsive {...props} minWidth={constants.BREAKPOINT_DESKTOP} />
export const IsMobileOrTablet = props => (
  <Responsive {...props} maxWidth={constants.BREAKPOINT_DESKTOP - 1} />
)
